import { useTranslation } from 'react-i18next';
import { Sheet, SheetContent, SheetDescription, SheetTitle } from '@/components/ui/sheet';
import type { SavedRoute } from './api';
import { formatKm } from './calc';

/** «Percorsi usuali»: the person's saved routes; one tap fills from, to and km (spec §2.1). */
export function RoutePicker({
  open,
  routes,
  onPick,
  onClose,
}: {
  readonly open: boolean;
  readonly routes: readonly SavedRoute[];
  readonly onPick: (route: SavedRoute) => void;
  readonly onClose: () => void;
}) {
  const { t } = useTranslation('expenses');
  return (
    <Sheet open={open} onOpenChange={(next) => (next ? undefined : onClose())}>
      <SheetContent
        side="bottom"
        className="max-h-[85vh] gap-3 overflow-y-auto rounded-t-xl p-4 lg:inset-x-auto lg:inset-y-0 lg:right-0
          lg:left-auto lg:h-full lg:max-h-none lg:w-[min(420px,88vw)] lg:rounded-none lg:border-l"
      >
        <SheetTitle>{t('mileage.routes.title')}</SheetTitle>
        <SheetDescription>{t('mileage.routes.pickHelp')}</SheetDescription>
        {routes.length === 0 ? (
          <p className="text-muted-foreground text-sm">{t('mileage.routes.empty')}</p>
        ) : (
          <ul className="flex flex-col gap-2">
            {routes.map((route) => (
              <li key={route.id}>
                <button
                  type="button"
                  className="border-border bg-card hover:bg-muted flex min-h-11 w-full items-center justify-between gap-3 rounded-xl border p-3 text-left"
                  onClick={() => onPick(route)}
                >
                  <span className="flex min-w-0 flex-col gap-0.5 font-semibold break-words">
                    <span>
                      <span className="text-muted-foreground font-normal">
                        {t('mileage.routes.fromShort')}{' '}
                      </span>
                      {route.from}
                    </span>
                    <span>
                      <span className="text-muted-foreground font-normal">
                        {t('mileage.routes.toShort')}{' '}
                      </span>
                      {route.to}
                    </span>
                  </span>
                  <span className="text-muted-foreground shrink-0 tabular-nums">
                    {formatKm(route.km)} km
                  </span>
                </button>
              </li>
            ))}
          </ul>
        )}
      </SheetContent>
    </Sheet>
  );
}
